import { createRouter, createWebHistory } from 'vue-router'
import CashierCustomization from '@/pages/CashierCustomization.vue'
const Demo = () => import(/* webpackChunkName: "Demo" */ '@/pages/Demo.vue')
const UsagePage = () =>
  import(
    /* webpackChunkName: "Usage", webpackPrefetch: true */ '@/pages/Usage.vue'
  )
const Showcase = () =>
  import(
    /* webpackChunkName: "Showcase", webpackPrefetch: true */ '@/pages/Showcase.vue'
  )

const routes = [
  {
    path: '/',
    redirect: 'configs'
  },
  {
    path: '/configs',
    name: 'CashierCustomization',
    component: CashierCustomization
  },
  {
    path: '/demo',
    name: 'Demo',
    component: Demo
  },
  {
    path: '/usage',
    name: 'Usage',
    component: UsagePage
  },
  {
    path: '/showcase',
    name: 'Showcase',
    component: Showcase
  }
]

const router = createRouter({
  history: createWebHistory('/cashier-config/'),
  routes
})

export default router
